export default {
  methods: {
    loadFacebookSDK() {
      let _this = this;
      this.$nextTick(() => {
        window.fbAsyncInit = function () {
          window.FB.init({
            appId: process.env.VUE_APP_FACEBOOK_APP_ID,
            xfbml: true,
            version: 'v12.0'
          });
          window.FB.AppEvents.logPageView();
          _this.FB = window.FB;
        };
        (function (d, s, id) {
          let js, fjs = d.getElementsByTagName(s)[0]
          if (d.getElementById(id)) { return }
          js = d.createElement(s); js.id = id
          js.src = '//connect.facebook.net/en_US/sdk.js'
          fjs.parentNode.insertBefore(js, fjs)
        }(document, 'script', 'facebook-jssdk'))
      });
    },
    runAsFacebookUser(callback) {
      let scopeConfig = {scope: 'pages_show_list,pages_messaging,pages_manage_metadata,instagram_manage_messages,instagram_basic'};
      window.FB.getLoginStatus(function(response) {
        if (response.status === 'connected') {
          scopeConfig.auth_type = 'rerequest';
        }
        window.FB.login(function(response) {
          if (response.authResponse) {
            return callback(response.authResponse);
          }
        }, scopeConfig);
      });
    },
  },
};
